

require('../../../../../resources/js/main-libs');
// <!-- BOOTSTRAP JS -->
require('../../assets/bootstrap/js/bootstrap.min.js');

//<!-- VIEWPORT -->

require('../../assets/plugins/viewport/jquery.viewport.js');

//<!-- MENU -->
require('../../assets/plugins/menu/hoverIntent.js');
require('../../assets/plugins/menu/superfish.js');

//<!-- FANCYBOX -->
require('../../assets/plugins/fancybox/jquery.fancybox.min.js');

//<!-- REVOLUTION SLIDER  -->
// require('../../assets/plugins/revolutionslider/js/jquery.themepunch.tools.min.js');
require('../../assets/plugins/revolutionslider/js/jquery.themepunch.revolution.min.js');
require('../../assets/plugins/revolutionslider/js/extensions/revolution.extension.actions.min.js');
require('../../assets/plugins/revolutionslider/js/extensions/revolution.extension.carousel.min.js');
require('../../assets/plugins/revolutionslider/js/extensions/revolution.extension.kenburn.min.js');
require('../../assets/plugins/revolutionslider/js/extensions/revolution.extension.layeranimation.min.js');
require('../../assets/plugins/revolutionslider/js/extensions/revolution.extension.migration.min.js');
require('../../assets/plugins/revolutionslider/js/extensions/revolution.extension.navigation.min.js');
require('../../assets/plugins/revolutionslider/js/extensions/revolution.extension.parallax.min.js');
require('../../assets/plugins/revolutionslider/js/extensions/revolution.extension.slideanims.min.js');
require('../../assets/plugins/revolutionslider/js/extensions/revolution.extension.video.min.js');

//<!-- OWL CAROUSEL -->
require('../../assets/plugins/owl-carousel/owl.carousel.min.js');

//<!-- PARALLAX -->
require('../../assets/plugins/parallax/jquery.stellar.min.js');
//<!-- ISOTOPE -->
require('../../assets/plugins/isotope/imagesloaded.pkgd.min.js');
require('../../assets/plugins/isotope/isotope.pkgd.min.js');


//<!-- CONTACT FORM VALIDATE & SUBMIT -->
// require('../../assets/plugins/validate/jquery.validate.min.js');
require('../../assets/plugins/submit/jquery.form.min.js');

//<!-- GOOGLE MAPS -->
// //<!--require('../..http://maps.google.com/maps/api/js?key=AIzaSyB3xJWuvLx4Ts5X2YsHnQigLOJWoGSM-5g');-->
// //<!--require('../../assets/plugins/googlemaps/gmap3.min.js');-->

//<!-- CHARTS -->
require('../../assets/plugins/charts/jquery.easypiechart.min.js');

//<!-- COUNTER -->
require('../../assets/plugins/counter/jquerysimplecounter.js');

//<!-- INSTAFEED -->
// require('../../assets/plugins/instafeed/instafeed.min.js');

//<!-- TWITTER -->
// require('../../assets/plugins/twitter/twitterfetcher.min.js');

//<!-- YOUTUBE PLAYER -->
// require('../../assets/plugins/ytplayer/jquery.mb.ytplayer.min.js');

//<!-- COUNTDOWN -->
require('../../assets/plugins/countdown/jquery.countdown.min.js');

//<!-- ANIMATIONS -->
// require('../../assets/plugins/animations/wow.min.js');

//<!-- CUSTOM JS -->
require('../../assets/js/custom.js');

require('../../../../../resources/js/main');


require('../../../../assets/js/jquery.mousewheel-3.0.6.pack.js');
require('../../../../assets/js/jquery.cycle.all.js');
// require('../../../../assets/js/csska.com.js');
// require('../../../../assets/js/jquery.jcarousel.min.js');
require('../../../../assets/libs/breeze/js/breeze.js');
require('../../../../assets/libs/nprogress/nprogress.js');
require('../../../../assets/libs/swfobject.js');
require('../../../../assets/libs/iamceege/tooltipster/js/jquery.tooltipster.js');
require('../../../../assets/js/social.js');

// require('../../assets/js/cabinet.js');
